import { useLocation } from 'react-router-dom';
import T from '@wojtekmaj/react-t';

import { stringify } from '@rewardopl/utils/url';

import { Button, Icon } from './login_with_google_button.styles';

import googleIcon from '../../../../static/google.svg';

export default function LoginWithGoogleButton() {
  const location = useLocation();

  const { returnPath = '/' } = (location.state || {}) as {
    returnPath?: string;
  };

  const href = `/api/auth/google${stringify({
    state: encodeURIComponent(JSON.stringify({ mobile: false, returnPath })),
  })}`;

  return (
    <Button as="a" href={href}>
      <Icon src={googleIcon} width={20} height={20} alt="Google" />
      <T>Sign in with Google</T>
    </Button>
  );
}
